module.exports = function () {
    const careersLandingCategoriesClass = 'careers-landing-categories';
    const careersLandingCategoriesListClass = 'careers-landing-categories-list';
    const careersLandingCategoriesOpenClass = 'careers-landing-categories-open';
    const careersLandingCategoriesExpandClass = 'careers-landing-categories-expand';

    $('.' + careersLandingCategoriesExpandClass).click(function () {
        $(this).parents('.' + careersLandingCategoriesClass).first().toggleClass(careersLandingCategoriesOpenClass);
    });

    const resizeCategoriesContainer = function() {
        $('.' + careersLandingCategoriesClass).each(function () {
            var newHeight = $(this).find('.' + careersLandingCategoriesListClass).outerHeight();

            if (ICF.Utils.Breakpoints.IsMobile()) {
                newHeight += 32;
            }

            $(this).height(newHeight);
        });
    };

    resizeCategoriesContainer();
    setTimeout(resizeCategoriesContainer, 100);
    $(window).resize(resizeCategoriesContainer);

    const resizePersonas = function() {
        $('.careers-landing-persona-content').each(function() {
            $(this).css('bottom', '-' + $(this).find('.careers-landing-persona-description').first().outerHeight() + 'px');
        });
    };

    resizePersonas();
    setTimeout(resizePersonas, 100);
    $(window).resize(resizePersonas);
};